// ========================================
// Start Sticky Header
// ========================================
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.prevScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.prevScrollDirection = '';
    this.header = this.querySelector('.header');
    this.nav = this.querySelector('.header__navigation');
    this.navLinks = this.querySelector('.navigation__links');
    this.mainContent = document.querySelector('.main-content');
    this.windowWidth = window.innerWidth;
    
    document.addEventListener('DOMContentLoaded', this.onLoad.bind(this));
    window.addEventListener('resize', this.onResize.bind(this));
    window.addEventListener('scroll', this.onscroll.bind(this));
  }

  onLoad() {
    // 1. Set Nav max-height
    if (this.nav) this.nav.style.maxHeight = getComputedStyle(this.navLinks).height;

    // 2. Update Main Content padding top
    const headerHeight = getComputedStyle(this).height;
    const mainContentPaddingTop = getComputedStyle(this.mainContent).paddingTop;

    if (parseInt(headerHeight) !== parseInt(mainContentPaddingTop)) this.mainContent.style.paddingTop = headerHeight;
  }

  onResize() {
    // Check window width - Safari resize event fix
    if (window.innerWidth === this.windowWidth) return;
    this.windowWidth = window.innerWidth;

    // 1. Update Nav max-height 
    if (this.nav) this.nav.style.maxHeight = getComputedStyle(this.navLinks).height;

    // 2. Update Main Content padding top
    for (let i = 1; i <= 300; i++) {
      setTimeout(() => {
        this.mainContent.style.paddingTop = getComputedStyle(this).height;
      }, i);
    }
  }

  onscroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const navHeight = parseInt(getComputedStyle(this.nav).height);
    const mobileSearchHeight = parseInt(getComputedStyle(this.querySelector('.header__search-mobile')).height);
    
    if (scrollTop > this.prevScrollTop && this.prevScrollDirection !== 'down') {
      if (window.innerWidth >= 990) {
        if (scrollTop >= navHeight) {
          // Scroll Down Large up
          this.onSrollDown();
          this.prevScrollDirection = 'down';
        }
      } else {
        if (scrollTop >= mobileSearchHeight) {
          // Scroll Down Medium down
          this.onSrollDown();
          this.prevScrollDirection = 'down';
        }
      }
    } else if (scrollTop < this.prevScrollTop && this.prevScrollDirection !== 'up') {
      // Scroll Up
      this.onSrollUp();
      this.prevScrollDirection = 'up';
    }  else if (scrollTop === 0) {
      // Scoll Top
      this.onScrollTop();

      // Update Main Content padding top
      for (let i = 1; i <= 300; i++) {
        setTimeout(() => {
          this.mainContent.style.paddingTop = getComputedStyle(this).height;
        }, i);
      }
    }

    this.prevScrollTop = scrollTop <= 0 ? 0 : scrollTop; // for Mobile or negative scrolling
  }

  onSrollDown() {
    this.header.classList.remove('scroll-up', 'scroll-top');
    this.header.classList.add('scroll-down');
  }

  onSrollUp() {
    this.header.classList.remove('scroll-down', 'scroll-top');
    this.header.classList.add('scroll-up');
  }

  onScrollTop() {
    this.header.classList.remove('scroll-up', 'scroll-down');
    this.header.classList.add('scroll-top');
  }
}

customElements.define('sticky-header', StickyHeader);
// ========================================
// End Sticky Header
// ========================================

// ========================================
// Start Mobile Menu
// ========================================
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.mobile-menu__btn');
    this.mobileMenu = this.querySelector('.mobile-menu');
    this.links = this.querySelectorAll('.mobile-menu__link');
    this.stickyHeader = document.querySelector('.sticky-header');
    this.backBtns = this.querySelectorAll('.back-btn');
    this.headerSearch = document.querySelectorAll('header-search');

    this.btn.addEventListener('click', this.btnOnClick.bind(this));
    this.links.forEach(el => {
      el.addEventListener('click', this.linkOnClick)
    })
    this.backBtns.forEach(el => {
      el.addEventListener('click', this.backBtnOnClick.bind(this));
    })
    window.addEventListener('resize', this.onResize.bind(this));
  }

  btnOnClick() {
    // 1. 'open' class
    this.classList.toggle('open');
    if (this.classList.contains('open')) {
      this.headerSearch.forEach(search => search.closeSearch());
    }

    // 2. Disable scroll
    document.body.classList.toggle('overflow-hidden');

    // 3. Set mobile-menu height
    this.mobileMenuHeight();
  }

  mobileMenuHeight() {
    this.mobileMenu.style.height = `calc(100dvh - ${getComputedStyle(this.stickyHeader).height})`;
  }

  linkOnClick(e) {
    if (this.classList.contains('has-submenu')) {
      e.preventDefault();
      
      // Open submenu
      this.closest('.mobile-menu__item').querySelector('.submenu').classList.add('open');
    }
  }

  backBtnOnClick() {
    this.querySelectorAll('.submenu').forEach(el => {
      el.classList.remove('open');
    })
  }

  onResize() {
    if (window.innerWidth > 990) this.closeMobileMenu();
  }

  closeMobileMenu() {
    if (this.classList.contains('open')) {
      this.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    }
  }
}

customElements.define('mobile-menu', MobileMenu);
// ========================================
// End Mobile Menu
// ========================================

// ========================================
// Start Footer Menu
// ========================================
class FooterMenu extends HTMLElement {
  constructor() {
    super();
    this.headers = this.querySelectorAll('.column__header');
    this.allcolContents = this.querySelectorAll('.column__content');

    this.headers.forEach(el => el.addEventListener('click', this.onclick));
    window.addEventListener('resize', this.onResize.bind(this));
  }

  onclick() {
    const col = this.closest('.menu__column');
    const colContent = col.querySelector('.column__content');
    const colContentContainer = col.querySelector('.column__content-container');

    // 1. 'open' class
    col.classList.toggle('open');

    // 2. Animate content
    if (col.classList.contains('open')) colContent.style.maxHeight = getComputedStyle(colContentContainer).height;
    else colContent.style.maxHeight = 0;
  }

  onResize() {
    if (window.innerWidth > 990) {
      this.allcolContents.forEach(el => el.classList.add('column__content--desktop'));
    } else {
      this.allcolContents.forEach(el => el.classList.remove('column__content--desktop'));
    }
  }
}

customElements.define('footer-menu', FooterMenu);
// ========================================
// End Footer Menu
// ========================================

// ========================================
// Start Footer Newsletter Form
// ========================================
class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('#newsletter-form');
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  onFormSubmit() {
    const input = this.querySelector('.newsletter__input');
    const successContent = this.querySelector('.newsletter__success');

    // 1. Show success message
    successContent.style.display = 'block';

    // 2. Clear input field
    setTimeout(() => {
      input.value = '';
    }, 300);

    // 3. Hide Success Message
    setTimeout(() => {
      successContent.style.display = 'none';
    }, 5000);
  }
}

customElements.define('newsletter-form', NewsletterForm)
// ========================================
// End Footer Newsletter Form
// ========================================

// ========================================
// Start Header Search
// ========================================
class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    // Variables
    this.searchBox = this.querySelector('.search-box');
    this.searchBoxForm = this.querySelector('.search-box__form');
    this.searchBoxInput = this.querySelector('.search-box__input');
    this.searchBoxIcon = this.querySelector('.search-box__icon');
    this.searchBoxClear = this.querySelector('.search-box__clear');
    this.searchSuggestions = this.querySelector('.search-suggestions');
    this.allResults = this.querySelector('.search-suggestions__all-results');
    this.collectionsContainer = this.querySelector('.search-suggestions__collections');
    this.productsContainer = this.querySelector('.search-suggestions__products');
    this.noResults = this.querySelector('.search-suggestions__no-results');
    this.searchOverlay = this.querySelector('.search-overlay');
    this.stickyHeader = document.querySelector('.sticky-header');
    this.mobileMenu = document.querySelector('mobile-menu');
    let searchTimer;

    // Events
    // Sumbit search form
    this.searchBoxIcon.addEventListener('click', this.submitSearchForm.bind(this));
    this.allResults.addEventListener('click', this.submitSearchForm.bind(this));

    // Input Change
    this.searchBoxInput.addEventListener('input', this.onInputChange.bind(this));
    this.searchBoxInput.addEventListener('focus', this.onInputChange.bind(this));

    // Clear text 
    this.searchBoxClear.addEventListener('click', this.closeSearch.bind(this));

    // Close
    window.addEventListener('keydown', e => {if (e.key === 'Escape') this.closeSearch()});
    this.searchOverlay.addEventListener('click', this.closeSearch.bind(this));

    // Resize
    window.addEventListener('resize', this.searchSuggestionsHeight.bind(this));
  }

  submitSearchForm() {
    if (this.searchBoxInput.value.length > 0) this.searchBoxForm.submit();
  }

  onInputChange() {
    if (this.searchBoxInput.value) {
      // 1. Show clear text
      this.searchBoxClear.classList.remove('hidden');
      // 2. Start Predictive Search API
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.predictiveSearch.bind(this), 300);
    } else {
      // 1. Hide clear text
      this.searchBoxClear.classList.add('hidden');
      // 2. Clear search suggestions
      this.clearSearchSuggestions();
    }
  }

  predictiveSearch() {
    const query = this.searchBoxInput.value;
    const type = 'resources[type]=product,collection';
    const limit = 'resources[limit]=6&resources[limit_scope]=each';
    const oosProducts = 'resources[options][unavailable_products]=last'
    const queryArr = query.split(' ').map(word => { 
      if (!word) return;
      return word[0].toUpperCase() + word.substring(1).toLowerCase(); 
    });

    fetch(`/search/suggest.json?q=${query}&${type}&${limit}&${oosProducts}`)
    .then(response => response.json())
    .then(suggestions => {

      const suggestedCollections = suggestions.resources.results.collections;
      const suggestedProducts = suggestions.resources.results.products;

      // 1. Clear Search Suggestions
      this.clearSearchSuggestions();

      // 2. Show Search Suggestions
      this.showSearchSuggestions();
      
      // a. If there's no results
      if (suggestedProducts.length < 1 && suggestedCollections.length < 1) {
        this.noResults.classList.remove('hidden');
        this.noResults.innerHTML = `<p>No hay coincidencias para '${query}'</p>`
      }

      // b. If there's any results
      if (suggestedProducts.length > 0 || suggestedCollections.length > 0) {
        this.allResults.classList.remove('hidden');
      }

      // I. Collections
      if (suggestedCollections.length > 0) {
        // 1. Show Collection Container
        this.collectionsContainer.classList.remove('hidden');

        // 2. Append Collections
        suggestedCollections.forEach(collection => {
          const title = collection.title.split(' ').map(titleWord => { 
            if (!titleWord) return;
            let matchedQuery;
            queryArr.forEach(queryString => {if (titleWord.includes(queryString)) matchedQuery = queryString;});
            if (matchedQuery) return titleWord.replaceAll(matchedQuery, `<span>${matchedQuery}</span>`);
            else return titleWord
          }).join(' ');
          const collectionHTML = `<a href="${collection.url}">${title}</a>`;
          this.collectionsContainer.insertAdjacentHTML("beforeend", collectionHTML);
        });
      }

      // II. Products
      if (suggestedProducts.length > 0) {
        // 1. Show Product Container
        this.productsContainer.classList.remove('hidden');

        // 2. Append Products
        suggestedProducts.forEach(product => {
          const title = product.title.split(' ').map(titleWord => { 
            if (!titleWord) return;
            let matchedQuery;
            queryArr.forEach(queryString => {if (titleWord.includes(queryString)) matchedQuery = queryString;});
            if (matchedQuery) return titleWord.replaceAll(matchedQuery, `<span>${matchedQuery}</span>`);
            else return titleWord
          }).join(' ');
          const imgURL = product.featured_image.url;
          const imgURLFirst = imgURL.slice(0, imgURL.lastIndexOf('.'));
          const imgURLLast = imgURL.slice(imgURL.lastIndexOf('.'));
          const imgRatio = `_200x200`;
          const imgURLOptimized = `${imgURLFirst}${imgRatio}${imgURLLast}`;
          const price = parseInt(product.price);
          const priceFormatted = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(price);
          const comparePrice = parseFloat(product.compare_at_price_max) > 0 ? parseInt(product.compare_at_price_max) : '';
          const comparePriceFormatted = comparePrice ? new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(comparePrice) : '';
          const productHTML = `
          <a href="${product.url}">
            <div class="product-box">
              <div class="product-box__image">
                <div class="image-container">
                  <img class="image-cover" src="${imgURLOptimized}" alt="${product.featured_image.alt}">
                </div>
              </div>

              <div class="product-box__info">
                <p class="product-box__title">${title}</p>
                <span class="product-box__price">
                  ${priceFormatted}
                  <span class="compare-price">${comparePriceFormatted}</span>
                </span>
              </div>
            </div>
          </a>`;

          this.productsContainer.insertAdjacentHTML("beforeend", productHTML);
        });
      }
    });
  }

  clearSearchSuggestions() {
    this.searchSuggestions.classList.add('hidden');
    this.allResults.classList.add('hidden');
    this.collectionsContainer.classList.add('hidden');
    this.collectionsContainer.innerHTML = '';
    this.productsContainer.classList.add('hidden');
    this.productsContainer.innerHTML = '';
    this.noResults.classList.add('hidden');
    this.noResults.innerHTML = '';
    this.searchOverlay.classList.add('hidden');
    document.body.classList.remove('overflow-hidden-medium');
  }

  showSearchSuggestions() {
    this.searchSuggestionsHeight();
    this.checkMobileMenu();
    this.searchSuggestions.classList.remove('hidden');
    this.searchOverlay.classList.remove('hidden');
    document.body.classList.add('overflow-hidden-medium');
  }

  searchSuggestionsHeight() {
    if (window.innerWidth < 990) {
      this.searchSuggestions.style.height = `calc(100dvh - ${getComputedStyle(this.stickyHeader).height})`;
    } else {
      this.searchSuggestions.style.height = 'auto';
    }
  }

  checkMobileMenu() {
    if (this.mobileMenu.classList.contains('open')) {
      this.mobileMenu.querySelector('.mobile-menu__btn').click();
    }
  }

  closeSearch() {
    this.clearSearchBoxInput();
    this.clearSearchSuggestions();
  }

  clearSearchBoxInput() {
    this.searchBoxInput.value = '';
    this.searchBoxClear.classList.add('hidden');
  }
}

customElements.define('header-search', HeaderSearch);
// ========================================
// End Header Search
// ========================================